import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { preinitSearch, updateHeaderHeight } from "./search"
import { defaultConfig } from "./config"

import "./styles/index.css"
import { getWizardConfig } from "./wizard"

preinitSearch('button.ExposedSearch__search-trigger');

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: '.site-header input[placeholder="Search"], #nosto-mobile-search-input',
    contentCssSelector: '#js-ajax-wrapper',
    serpUrlMapping: {
        query: "query",
        "products.filter": "filter",
        "products.page": "page",
        "products.size": "size",
        "products.sort": "sort"
    },
    serpPath: '/search',
    serpPathRedirect: !location.pathname.includes('/search'),
    serpQuery: {
        products: {
            sort: [{ field: "stats.revenue", order: "desc" }],
            fields: [
                "productId", "url", "name", "availability",
                "imageUrl", "alternateImageUrls", "inventoryLevel",
                "customFields.key", "customFields.value",
                "price", "listPrice", "tags1",
                "skus.name", "skus.id","skus.availability", 
                "skus.customFields.key", "skus.customFields.value",
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url","name", "availability",
                "imageUrl", "alternateImageUrls", "inventoryLevel",
                "customFields.key", "customFields.value",
                "price", "listPrice", "tags1",
                "skus.name", "skus.id","skus.availability", 
                "skus.customFields.key", "skus.customFields.value",
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    persistentSearchCache: true,
    preservePageScroll: true,
    categoryCssSelector: '#js-ajax-wrapper',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [
                    "productId", "url","name", "availability",
                    "imageUrl", "alternateImageUrls", "inventoryLevel",
                    "customFields.key", "customFields.value",
                    "price", "listPrice", "tags1",
                    "skus.name", "skus.id","skus.availability", 
                    "skus.customFields.key", "skus.customFields.value",
                ],
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },

    // Apply configuration wizard last
    ...getWizardConfig(),
    // Configuration here will override the changes in the wizard
}).then(() => {
    // for sticky toolbar + top padding on pages
    let wasScrolled = document.body.classList.contains('scrolled');

    const observer = new MutationObserver(() => {
        const isScrolled = document.body.classList.contains('scrolled');
        if(isScrolled !== wasScrolled) {
            wasScrolled = isScrolled;
            setTimeout(() => { updateHeaderHeight() }, 300); //wait for transition
        }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    updateHeaderHeight();

    /* g4 event for load more button press: */
    let clicks = 0;
    document.querySelector('.ns-serp')?.addEventListener('click', (e) => {
        if(!e.target.closest('.ns-loadmore-button')) return;
        clicks++;

        gtag("event", "nosto_load-more", {
            page_url: window.location.href,
            click_count: clicks
        });
    })
})